import { useAppSelector } from '@/redux/hooks'
import AdvisorMessages from './AdvisorMessages'
import NegotiationMessages from './NegotiationMessages'
import AIPlayerMessages from './AIPlayerMessages'
import { ActiveTab, isAIPlayerTab } from '@/constants/chat'
import React from 'react'

const MessageList: React.FC = React.memo(() => {
  const activeTab = useAppSelector((state) => state.chat.activeTab)
  return activeTab === ActiveTab.Advisor ? (
    <AdvisorMessages />
  ) : isAIPlayerTab(activeTab) ? (
    <AIPlayerMessages />
  ) : activeTab === ActiveTab.Decision ? null : (
    <NegotiationMessages activeTab={activeTab} />
  )
})

export default MessageList
